export default "__VITE_ASSET__2981149a__"